// TODO: remove
export function copyTextToClipboard(text: string): boolean | Promise<void> {
  if ('clipboard' in navigator) {
    return navigator.clipboard.writeText(text)
  } else {
    return document.execCommand('copy', true, text)
  }
}
